import { get } from 'lodash';
import { useQuery } from '@apollo/client/react';
import { ProjectDashboardDocument } from 'graphql/generated/graphql';

const useProjectDashboardQuery = (projectId: string) => {
  const { loading, data } = useQuery(ProjectDashboardDocument, {
    variables: { id: projectId },
    fetchPolicy: 'cache-and-network',
  });

  const project = get(data, 'project', null);

  return [project, loading] satisfies [typeof project, boolean];
};

export default useProjectDashboardQuery;
